import { normalizeJson } from '../../shared/helpers';
import { useRepo } from "pinia-orm";

// TODO: Refactor this to use the new ORM - somehow it does not order correctly

export const draggableItemsForm = (items, Item, mode = 'multiple') => ({
    computed: {
        items: {
            get() {
                return this.unselectedItems();
            }
        },
        chosenItems: {
            get() {
                return this.selectedItems();
            },
            set(items) {
                this.resort(items);
            }
        }
    },
    methods: {
        fetchItems() {
            this.fetchingItems = true;

            items.index({ offset: 0, limit: 999 }).then(result => {
                return useRepo(Item).save(normalizeJson(result.data));
            }).then(inserts => {
                this.fetchingItems = false;
            });
        },
        deleteItem(itemId) {
            this.performingDeleteRequest = true;

            items.destroy(itemId).then(() => {
                useRepo(Item).destroy(itemId);
            }).then(() => {
                this.deleting = null;
                this.performingDeleteRequest = false;
                let index = this.selectedIndex(itemId);

                if (index >= 0) {
                    this.form.items.splice(index, 1);
                }
            });
        },
        toggleItem(itemId) {
            let index = this.selectedIndex(itemId);

            if (index === -1) {
                if (mode === 'single' && this.form.items.length > 0) {
                    this.form.items = [];
                }

                this.form.items.push({
                    id: itemId,
                    order: this.sortOrder.length
                });
            } else {
                this.form.items.splice(index, 1);
            }

            this.form.items.sort((a, b) => (a.order - b.order));
        },
        edit(item) {
            this.editing = item;
        },
        confirmDelete(item) {
            this.deleting = item;
        },
        cancelDelete() {
            this.deleting = null;
        },
        create() {
            this.creating = true;
        },
        cancelCreate() {
            this.creating = false;
        },
        cancelEdit() {
            this.editing = null;
        },
        resort(items) {
            this.sortOrder = this.idsOrder(items);
        },
        selectedIndex(itemId) {
            return this.form.items.findIndex(data => (data.id === itemId));
        },
        isSelected(itemId) {
            return this.selectedIndex(itemId) > -1;
        },
        unselectedItems() {
            let items = useRepo(Item).withAll();

            switch (typeof this.defaultSort) {
                case 'string':
                    items.orderBy(this.defaultSort);
                    break;
                case 'object':
                    let keys = Object.keys(this.defaultSort);
                    items.orderBy(
                        this.defaultSort[keys[0]], this.defaultSort[keys[1]]);
                    break;
                default:
                    items.orderBy('updated_at', 'desc');
                    break;
            }

            if (this.form.items.length > 0) {
                let ids = this.idsOrder(this.form.items);
                items.where((item) => {
                    return !ids.includes(item.id);
                });
            }

            return items.get();
        },
        selectedItems() {
            let ids = this.idsOrder(this.form.items);

            let selectedItems = useRepo(Item).withAll().whereIn('id', ids).get();

            if (this.sortOrder.length > 0) {
                let oldOrder = this.idsOrder(selectedItems);

                this.addOrderValue(selectedItems);

                selectedItems.sort((a, b) => (a.order - b.order));

                if (this.hasOrderChanged(selectedItems, oldOrder)) {
                    this.updateFormItemsOrder(selectedItems);
                }
            }

            this.sortOrder = this.idsOrder(selectedItems);

            return selectedItems;
        },
        idsOrder(items) {
            return items.map((item, index) => {
                return (item.id)
            });
        },
        addOrderValue(items) {
            let sort = this.sortOrder.length === items.length ? this.sortOrder : this.form.items;

            items.map((item, index) => { item.order = sort.indexOf(item.id) });
        },
        hasOrderChanged(items, oldOrder) {
            return this.idsOrder(items).join(',') !== oldOrder.join(',');
        },
        updateFormItemsOrder(items) {
            this.form.items.map((item, index) => {
                item.order = items.findIndex(q => q.id === item.id)
            });

            this.form.items.sort((a, b) => (a.order - b.order));
        }
    },
    mounted() {
        this.fetchItems();
    }
})
